import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { DefaultValuesService } from 'src/app/services/defaultvalues.service';
import { EquipmentManagenementService } from 'src/app/services/equipmentmanagement.service';

@Component({
    selector: 'addlevel-ota',
    standalone: false,
    templateUrl: './otasettings-add.component.html',
    styleUrls: ['../../../../../style/custom-mat-dialog.component.less']
})
export class AddLevelOtaComponent implements OnInit {
    @Output() levelInitializedTrigger = new EventEmitter<OtaSettingsLevel>();

    environments: SelectList[] = [];
    tenants: SelectList[] = [];

    public formGroup: FormGroup;

    constructor(
        private readonly dialogRef: MatDialogRef<AddLevelOtaComponent>,
        private readonly defaults: DefaultValuesService,
        private readonly fb: FormBuilder,
        private readonly emtConfigurationService: EquipmentManagenementService,
        private readonly toastService: ToastrService
    ) {
        this.formGroup = this.fb.group({
            environment: [null, Validators.required],
            tenant: [null]
        });
    }

    ngOnInit() {
        this.environments = this.defaults.environments.map(x => ({
            value: x.toUpperCase(),
            text: x.toUpperCase()
        }));
    }

    onEnvironmentChanged($event: any) {
        this.tenants = this.emtConfigurationService.getTenantsByEnvironment($event.value, this.defaults.tenants);
    }

    closeDialog(event: any) {
        event.preventDefault();
        this.dialogRef.close();
    }

    onSubmit() {
        if (this.formGroup.valid) {
            this.saveLevel();
        }
    }

    private saveLevel() {
        const newLevel = this.createFormRequest();
        this.emtConfigurationService.addOtaLevel(
            newLevel,
            () => {
                this.levelInitializedTrigger.emit(newLevel);
                this.dialogRef.close();
            },
            (error: any) => {
                if (error.status === 409) {
                    this.toastService.warning(error.error);
                } else {
                    this.toastService.error('Unable to save new OTA level.');
                }
            }
        );
    }

    private createFormRequest(): OtaSettingsLevel {
        return {
            environment: this.formGroup.get('environment')!.value,
            tenantId: this.formGroup.get('tenant')?.value
        };
    }
}
